import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
	textAreaWrapper: {
		marginTop: 4,
		marginLeft: 32
	}
})

export default useStyles
